import { render, staticRenderFns } from "./CulturalExpoExhibition.vue?vue&type=template&id=4b43c9fb&scoped=true&"
import script from "./CulturalExpoExhibition.vue?vue&type=script&lang=js&"
export * from "./CulturalExpoExhibition.vue?vue&type=script&lang=js&"
import style0 from "./CulturalExpoExhibition.vue?vue&type=style&index=0&id=4b43c9fb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43c9fb",
  null
  
)

export default component.exports